
import Detail from './Detail';
import Header from './Header';
import Info from './Info';
import Item from './Item';
import Metric from './Metric';

export default Info;
export {
  Detail,
  Header,
  Item,
  Metric,
};



// WEBPACK FOOTER //
// ./src/components/Info/index.js